export default "__VITE_ASSET__CSAY7B88__"